export enum SlideDirection {
  down = "down",
  up = "up",
  left = "left",
  right = "right",
  none = "none",
}
